// extracted by mini-css-extract-plugin
export var actions = "_uo-4";
export var item = "_uo-1";
export var price = "_uo-3";
export var quantity = "_uo-2";
export var table = "_uo-0";